import React, { Component, Fragment } from 'react'
import { Button, Popconfirm } from 'antd'
import CKEditor from '@ckeditor/ckeditor5-react'
import CKEditorInline from '@ckeditor/ckeditor5-build-inline'
import { policies } from '@services/api'

class EditDescription extends Component<any, any> {
    state = {
        description: '',
        edited: null,
        showButtons: false
    }

    componentDidMount() {
        const { description } = this.props
        this.setState({ description })
    }

    handleUpdateEdited = async edited => {
        this.setState({ edited, showButtons: true })
    }

    handleResetEdited = async () => {
        await this.setState({ edited: null })
        this.setState({ showButtons: false })
    }

    handleSubmitField = async () => {
        const { policy_id } = this.props
        const { edited } = this.state
        if (edited) {
            await policies.updateField({ id: policy_id, name: 'short_description', value: edited })
            this.setState({ description: edited, edited: null, showButtons: false })
            this.props.descriptionUpdated()
        }
    }

    render() {
        const { edited, description, showButtons } = this.state
        const { disable } = this.props
        const buttons =
            showButtons && !disable ? (
                <div style={{ marginTop: '1rem' }}>
                    <Button onClick={() => this.handleResetEdited()}>בטל שינויים</Button>
                    <Popconfirm
                        title="האם לעדכן תיאור פוליסה?"
                        onConfirm={() => this.handleSubmitField()}
                        okText="כן"
                        cancelText="לא"
                    >
                        <Button type="primary">שמירה</Button>
                    </Popconfirm>
                </div>
            ) : (
                ''
            )
        return (
            <Fragment>
                <CKEditor
                    data={edited ? edited : description === null ? '' : description}
                    editor={CKEditorInline}
                    disabled={disable}
                    onChange={(event, editor) => {
                        const data = editor.getData()
                        this.handleUpdateEdited(data)
                    }}
                    config={{
                        language: 'he',
                        toolbar: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'link',
                            'bulletedList',
                            'numberedList',
                            'blockQuote',
                            'insertTable',
                            'undo',
                            'redo'
                        ]
                    }}
                />
                {buttons}
            </Fragment>
        )
    }
}

export default EditDescription
